import { Notification } from "@drone-js/core";
import { useOnboardingPageContextAtomValue } from "apps/oneOnboarding/onboardingPageContextAtom";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import type { OnboardingPageContext } from "libs/codegen/property-onboarding/models/onboarding-page-context";
import { useMemo } from "react";

export const PropertyLicenseRequiredNotification = () => {
    const { propertiesContext } = (useOnboardingPageContextAtomValue() ?? {}) as OnboardingPageContext;
    const {
        cmsData: {
            publish: { licenseRequiredToPublish, enterLicenseToContinue },
        },
    } = useStaticDataAtomValue();

    const isLicenseRequired = useMemo(() => {
        if (!propertiesContext) return false;
        return Object.values(propertiesContext).some((property) => {
            const licenseConfiguration = property.licenseConfiguration;
            if (!licenseConfiguration) return false;

            // TODO(PRO-841): Include requiredFileUpload when the file upload flow is implemented.
            return licenseConfiguration.requiredExemptible === true || licenseConfiguration.requiredLicenseId === true;
        });
    }, [propertiesContext]);

    if (!isLicenseRequired) return null;

    return (
        <Notification
            intent="warning"
            title={licenseRequiredToPublish}
            description={enterLicenseToContinue}
            asset={{
                id: "fill.symbol.circle-exclamation",
            }}
            density="compact"
        />
    );
};
